import { useEffect, useState } from "react";
import { Mail, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SITE } from "@/lib/site";

const LINKS = [
  { label: "About Us", href: "#about" },
  { label: "Network", href: "#partners" },
  { label: "Why Us", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl transition-all duration-300 ${
        scrolled
          ? "bg-white/85 border-b border-slate-200/80 shadow-sm"
          : "bg-white/60 border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-20 items-center justify-between">
          <Logo variant="dark" />

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="text-sm font-medium text-slate-600 hover:text-[#0B2545] transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.mailto}
              data-testid="nav-email-us-button"
              className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-5 py-2.5 text-sm font-semibold text-[#0B2545] shadow-lg shadow-amber-500/25 transition-all duration-200 hover:bg-amber-400 hover:-translate-y-0.5 active:scale-95 focus-visible:ring-2 focus-visible:ring-amber-600 focus-visible:ring-offset-2"
            >
              <Mail className="h-4 w-4" /> Email Us
            </a>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-lg text-[#0B2545]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-slate-200/80 bg-white/95 backdrop-blur-xl"
        >
          <div className="px-4 py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                className="rounded-lg px-3 py-3 text-base font-medium text-slate-700 hover:bg-slate-100 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <a
              href={SITE.mailto}
              data-testid="mobile-nav-email-us-button"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 px-5 py-3 text-base font-semibold text-[#0B2545]"
            >
              <Mail className="h-4 w-4" /> Email Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
